var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-unstyled g-min-width-100x unify-list",class:{ 'g-mb-30': _vm.showMargin, 'mb-0': _vm.showMargin === false }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }